import {
    get_mezzi,
    get_mezzo,
    get_mezzo_by_qr,
    get_mezzo_kpi,
    create_mezzo,
    update_mezzo,
    duplica_mezzo,
    delete_mezzo,
} from "@/api/api.mezzo.js";

const mezzi = {
    namespaced: true,

    state: {
        lista: [],
        corrente: null,
        kpi: null,
    },

    mutations: {
        SET_LISTA: (state, lista) => {
            state.lista = lista;
        },
        SET_CORRENTE: (state, mezzo) => {
            state.corrente = mezzo;
        },
        SET_KPI: (state, kpi) => {
            state.kpi = kpi;
        },
    },

    actions: {
        carica({ commit }, filtri) {
            return new Promise((resolve, reject) => {
                get_mezzi(filtri).then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaDettaglio({ commit }, id) {
            return new Promise((resolve, reject) => {
                get_mezzo(id).then(resp => {
                    commit("SET_CORRENTE", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaDaQr({ commit }, publicCode) {
            return new Promise((resolve, reject) => {
                get_mezzo_by_qr(publicCode).then(resp => {
                    commit("SET_CORRENTE", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaKpi({ commit }) {
            return new Promise((resolve, reject) => {
                get_mezzo_kpi().then(resp => {
                    commit("SET_KPI", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salva(_ctx, { id, dati }) {
            return id ? update_mezzo(id, dati) : create_mezzo(dati);
        },

        elimina(_ctx, { id, conferma } = {}) {
            return delete_mezzo(id, conferma);
        },

        duplica(_ctx, id) {
            return duplica_mezzo(id);
        },
    },

    getters: {
        lista: state => state.lista,
        corrente: state => state.corrente,
        kpi: state => state.kpi,
    },
};

export default mezzi;
